// extracted by mini-css-extract-plugin
export default {"hideTooltip":"__-z","fadeIn":"aaa-z","delay":"baa-z","recommendedSizeTooltip":"caa-z"};